import http from '@/plugins/api'
import { startLoading } from '@/plugins/loading'
import * as types from './types'

export default {
  setSearchTerm({ commit }, text) {
    commit(types.SET_SEARCH_TERM, text)
  },
  setPageSize({ commit }, pageSize) {
    commit(types.SET_PAGE_SIZE, pageSize)
  },
  setSortDir({ commit }, sortDir) {
    commit(types.SET_SORT_DIR, sortDir)
  },
  setOrderBy({ commit }, orderBy) {
    commit(types.SET_ORDER_BY, orderBy)
  },
  setFilterBy({ commit }, filterBy) {
    commit(types.SET_FILTER_BY, filterBy)
  },
  setFilterOptions({ commit }, data) {
    commit(types.SET_FILTER_OPTIONS, data)
  },
  initTestdrive({ commit }, data) {
    commit(types.INIT_TESTDRIVE, data)
  },
  initTestdriveDrive({ commit }, data) {
    commit(types.INIT_TESTDRIVEDRIVE, data)
  },
  initTestdriveWaypoint({ commit }, data) {
    commit(types.INIT_TESTDRIVEWAYPOINT, data)
  },
  setTestdriveWaypoint({ commit }, data) {
    commit(types.SET_TESTDRIVEWAYPOINT, data)
  },
  updateTestdrive({ commit }, data) {
    commit(types.UPDATE_TESTDRIVE, data)
  },
  updateDrive({ commit }, data) {
    commit(types.UPDATE_TESTDRIVEDRIVE, data)
  },
  updateWaypoint({ commit }, data) {
    commit(types.UPDATE_TESTDRIVEWAYPOINT, data)
  },
  async getTestdriveTypeRates({ commit, dispatch }, firm) {
    const r = await startLoading(dispatch, 'getTestdriveTypeRates', () => http.get(`testdrive/testdriveTypeRates?firm=${firm}`))
    commit(types.SET_TESTDRIVETYPERATES, r.data)
    return r.data
  },
  async saveTestdriveTypeRates({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'saveTestdriveTypeRates', () => http.post('testdrive/saveTestDriveTypeRates', data))
    return r.data
  },
  async getTestdrives({ commit, dispatch }, searchOptions) {
    const r = await startLoading(dispatch, 'getTestdrives', () =>
      http.get('testdrive/testdrives', {
        params: searchOptions
      })
    )
    commit(types.SET_TESTDRIVES, r.data)
    return r.data
  },
  async getTestdrive({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getTestdrive', () => http.get(`testdrive/testdrive?id=${id}`))
    commit(types.SET_TESTDRIVE, r.data)
    return r.data
  },
  async saveTestdrive({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'saveTestdrive', () => http.post('testdrive/saveTestDrive', data))
    return r.data
  },
  async getTestdriveDrives({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getTestdriveDrives', () => http.get(`testdrive/drives?testdrive=${id}`))
    commit(types.SET_TESTDRIVEDRIVES, r.data)
    return r.data
  },
  async getTestdriveDrive({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getTestdriveDrive', () => http.get(`testdrive/drive?id=${id}`))
    commit(types.SET_TESTDRIVEDRIVE, r.data)
    return r.data
  },
  async getOwnerTestdrives({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getOwnerTestdrives', () => http.get(`testdrive/ownerTestdrives?contact=${id}`))
    commit(types.SET_TESTDRIVES, r.data)
    return r.data
  },
  async saveTestdriveDrive({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'saveTestdriveDrive', () => http.post('testdrive/saveDrive', data))
    return r.data
  },
  async deleteTestdriveDrive({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'deleteTestdriveDrive', () => http.post('testdrive/deleteDrive', data))
    return r.data
  },
  async getTestdriveWaypoints({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getTestdriveWaypoints', () => http.get(`testdrive/waypoints?testdrivedrive=${id}`))
    commit(types.SET_TESTDRIVEWAYPOINTS, r.data)
    return r.data
  },
  async getTestdriveWaypoint({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getTestdriveWaypoint', () => http.get(`testdrive/waypoint?id=${id}`))
    commit(types.SET_TESTDRIVEWAYPOINT, r.data)
    return r.data
  },
  async saveTestdriveWaypoint({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'saveTestdriveWaypoint', () => http.post('testdrive/saveWaypoint', data))
    return r.data
  },
  async deleteTestdriveWaypoint({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'deleteTestdriveWaypoint', () => http.post('testdrive/deleteWaypoint', data))
    return r.data
  },
  async getTestDriveMap({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getTestDriveMap', () => http.get(`report/drivemap?testdrivedrive=${data.testdrivedrive}&refresh=${data.refresh}`))
    return r.data
  },
  async sendReport({ commit, dispatch }, report) {
    const r = await startLoading(dispatch, 'sendReport', () => http.get(`report/send${report.report}?testdrivedrive=${report.testdrivedrive}`))
    return r.data
  },
  async getRecommendations({ commit, dispatch }, options) {
    const r = await startLoading(dispatch, 'getRecommendations', () =>
      http.get('testdrive/testdriveRecommendations', {
        params: options
      })
    )
    return r.data
  },
  async shortenUrl({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'shortenUrl', () => http.post('ShortenUrl', data))
    commit(types.SET_VIDEO_URL, r.data)
    return r.data
  },
  async getWeatherById({ commit, dispatch }, weather) {
    const r = await startLoading(dispatch, 'getWeatherById', () => http.get(`testdrive/weather?weather=${weather}`))
    commit(types.SET_WEATHER, r.data)
    return r.data
  },
  async getVideo({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getVideo', () => http.get(`testdrive/videolink?id=${id}`))
    commit(types.SET_VIDEOLINK, r.data)
    return r.data
  },
  async getTestdriveResults({ commit, dispatch }, testdrivedrive) {
    const r = await startLoading(dispatch, 'getTestdriveResults', () => http.get(`testdrive/driveResults?testdrivedrive=${testdrivedrive}`))
    commit(types.SET_TESTDRIVERESULTS, r.data)
    return r.data
  },
  async saveTestdriveResults({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'saveTestdriveResults', () => http.post('testdrive/saveDriveResults', data))
    return r.data
  },
  async getReportPreference({ commit, dispatch }, testdrivedrive) {
    const r = await startLoading(dispatch, 'getReportPreference', () => http.get(`report/reportPreference?testdrivedrive=${testdrivedrive}`))
    commit(types.SET_REPORTPREFERENCE, r.data)
    return r.data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/testdrives/actions.js